import { Component, OnInit } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl } from '@angular/forms';
import { StepIndicatorService } from 'lib/ng2-sapmp/src/ui-components/step-indicator';
import { BreadCrumbService } from 'lib/ng2-sapmp/src/ui-components/breadcrumb';
import { UserWizardService, AuthenticationService, UtilityService } from 'lib/ng2-sapmp/src/providers';
import { UserWizardModel, UserProfileModel } from 'lib/ng2-sapmp/src/models';
import { UserWizardDataService } from './../users-wizard-data-service';
import { ANALYTICS_CONSTANTS, PIVOTS } from 'config';
import { PageLoaderService } from 'lib/ng2-sapmp/src/ui-components/page-loader';
import { RequestModel } from './request-model';
import { MobilePivotModel } from 'lib/ng2-sapmp/src/ui-components/mobile-pivot/mobile-pivot.model';

@Component({
  selector: 'app-manage-users-action',
  providers: [UserWizardDataService],
  templateUrl: './action.component.html',
  styleUrls: ['./../manage-users.component.scss']
})
export class ActionComponent implements OnInit {
  actionForm: FormGroup;
  actionValid: boolean;
  userWizardModel: UserWizardModel = null;
  pivots: Array<MobilePivotModel>;
  user: UserProfileModel;
  requestModel: RequestModel;
  errorMessage: string;
  errorFlag = false;
  actionAssignUnassign = false;
  parentUrl: string;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private stepindicatorService: StepIndicatorService,
    private userWizardService: UserWizardService, private pageloaderService: PageLoaderService,
    private userWizardDataService: UserWizardDataService, private breadCrumbService: BreadCrumbService,
    private authenticationService: AuthenticationService, private utilityService: UtilityService
  ) {
    this.actionValid = false;
    this.pivots = new Array<MobilePivotModel>();
  }

  ngOnInit() {
    this.pageloaderService.setPageLoaderStatus(false);
    // this.parentUrl = this.utilityService.getParentUrl(this.router.url);
    this.authenticationService.setLoginSuccessUrl(this.router.routerState.snapshot.url);
    if (sessionStorage.getItem('assign-wizard') === null) {
      this.router.navigate(['/home']);
    } else {
      document.title = this.utilityService.getPageTitleConfig()[this.router.routerState.snapshot.url];
      this.stepindicatorService.setCurrentStep(this.activatedRoute.snapshot.url[0].path);
      this.userWizardModel = this.userWizardService.fetchSessionData();
      const url = this.breadCrumbService.filterCurrentUrl(this.userWizardModel.previousUrl);
      const pivotUrl = '/' + url;
      if (PIVOTS[pivotUrl]) {
        this.pivots.push({ label: PIVOTS[pivotUrl], routerLink: this.userWizardModel.previousUrl });
      }
      this.pivots.push({ label: 'Console dashboard', routerLink: '/dashboard' });
      this.userWizardService.setPivot(this.pivots);

      const actionType = this.userWizardModel.actionType === undefined ? 'ASSIGN' : this.userWizardModel.actionType;
      this.actionForm = new FormGroup({
        userAction: new FormControl(actionType),
      });
      this.breadCrumbService.getLastUrlFromBreadCrumb();
      this.userWizardDataService.createPageLoadProperties([], this.router.routerState.snapshot.url,
        'Manageusers Page - Step1', ANALYTICS_CONSTANTS.FRIENDLY_NAME_MANAGE_USER_ACTION);
      if (this.userWizardModel.actionType) {
        this.userWizardService.setMessage(this.userWizardModel.actionType === 'ASSIGN' ? 'Assign licenses' : 'Un-assign licenses');
      } else {
        this.userWizardService.setMessage('Assign or un-assign licenses');
      }
      this.userWizardDataService.tokenRefresh();
    }
    this.requestModel = new RequestModel();
    this.requestModel.fetchCriteria = {
      'class': 'API::SepPagingLoadConfig', 'limit': 10, 'offset': 0,
      'sortDir': 'DESC', 'sortField': 'name'
    };
    this.requestModel.class = 'API::ServiceOfferingCriteria';
    this.requestModel.excludeAddons = true;
    this.user = JSON.parse(sessionStorage.getItem('user')).user;
    this.userWizardDataService.getProductDetails(this.user.companyId, this.requestModel).subscribe(response => {
      if (response && response.totalLength === 0) {
        this.pageloaderService.setPageLoaderStatus(true);
        this.errorFlag = true;
        this.userWizardModel = null;
        this.actionAssignUnassign = false;
        //  this.errorMessage = 'No product licenses are available to ';
      } else {
        this.pageloaderService.setPageLoaderStatus(true);
        this.actionAssignUnassign = true;
      }


    }, error => {
      this.pageloaderService.setPageLoaderStatus(true);
      this.errorMessage = 'We couldn\'t complete your request. Please try again later.';

    });
  }

  goToNextStep(value) {
    if ((this.userWizardModel.actionType) && (this.userWizardModel.actionType !== value)) {
      delete this.userWizardModel.productList;
      delete this.userWizardModel.selectedProductList;
    }
    this.userWizardModel.actionType = value;
    delete this.userWizardModel.userList;
    delete this.userWizardModel.selectedUserList;
    delete this.userWizardModel.selectedUsersIds;
    this.userWizardService.addProductList(this.userWizardModel);
    this.router.navigate(['/manageUsers/products'], { relativeTo: this.activatedRoute });
  }

  cancel() {
    /*if (this.userWizardModel.createUser) {
      this.breadCrumbService.removeLastBreadCrumb();
    }*/
    this.breadCrumbService.removeLastBreadCrumb();
    this.stepindicatorService.removeStep('manageUsers');
    this.userWizardDataService.cancel(this.userWizardModel.previousUrl);
  }

  private getPreviousUrlPath() {
    return sessionStorage.getItem('previousRoute');
  }
  goToBulkUpload() {
    this.utilityService.setSuccessMessage(undefined);
    sessionStorage.setItem('bulk-sourcePreviousRoute', this.userWizardModel.previousUrl);
    this.stepindicatorService.removeStep('bulkUsers');
    this.breadCrumbService.removeLastBreadCrumb();
    this.router.navigate(['/bulkUsers']);
  }

  goToAddUserPage() {
    this.userWizardModel.createUser = true;
    this.userWizardService.addProductList(this.userWizardModel);
    this.breadCrumbService.removeLastBreadCrumb();
    this.router.navigate(['/user/add']);
  }
}
